import { AdyenTransactionService } from "@/infrastructure/services/AdyenTransactionService";
import { ErrorHandler, ERROR_CONTEXTS } from "@/shared/utils/errorHandler";
import { logger } from "@/infrastructure/services/LoggerService";
export class TransactionUseCases {
    constructor(transactionService) {
        Object.defineProperty(this, "transactionService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.transactionService = transactionService || new AdyenTransactionService();
    }
    /**
     * Initialize the transaction dashboard
     * Sets up Adyen Platform Experience and mounts components
     */
    async initializeTransactionDashboard(overviewSelector = "#transactions-overview-container", onRecordSelection) {
        try {
            // Initialiser uniquement l'overview avec la session
            const components = await this.transactionService.initializeTransactionComponents({
                onSessionCreate: () => this.transactionService.createSession(),
                onRecordSelection,
            });
            // Monter uniquement l'overview
            this.transactionService.mountComponents(components, overviewSelector);
            return components;
        }
        catch (error) {
            // Use the centralized error handler with automatic navigation logic
            ErrorHandler.handleApiError(error, ERROR_CONTEXTS.TRANSACTION_INITIALIZATION);
            throw error;
        }
    }
    /**
     * Handle transaction selection from the overview
     */
    handleTransactionSelection(transactionId) {
        try {
            this.transactionService.handleTransactionSelection(transactionId);
        }
        catch (error) {
            // Transaction selection errors should not navigate away
            ErrorHandler.handleApiError(error, ERROR_CONTEXTS.TRANSACTION_SELECTION, false);
            throw error;
        }
    }
    /**
     * Initialize Transaction Details modal
     * Opens a popup with transaction details using the Adyen transaction identifier
     */
    async initializeTransactionDetails(containerSelector, adyenTransactionId) {
        try {
            await this.transactionService.initializeTransactionDetails(containerSelector, adyenTransactionId);
        }
        catch (error) {
            ErrorHandler.handleApiError(error, ERROR_CONTEXTS.TRANSACTION_INITIALIZATION);
            throw error;
        }
    }
    /**
     * Update the locale of the transaction components
     */
    async updateLocale(newLocale, overviewSelector = "#transactions-overview-container") {
        try {
            await this.transactionService.updateLocale(newLocale, overviewSelector);
        }
        catch (error) {
            logger.debug("Error updating transaction locale:", error);
            // Don't throw to avoid breaking the UI
        }
    }
    /**
     * Cleanup transaction dashboard resources
     * Should be called when the component is unmounted
     */
    cleanup() {
        try {
            this.transactionService.cleanup();
        }
        catch (error) {
            logger.debug("Error during transaction dashboard cleanup:", error);
            // Don't throw cleanup errors to avoid breaking component unmounting
        }
    }
}
